import gql from 'graphql-tag';

export const GET_ACCOUNT_OWNED_BROADCASTS = gql`
  query AccountOwnedBroadcasts {
    broadcast {
      accountOwnedBroadcasts {
        broadcastId
        accountId
        type
        title
        status
        effectiveDateTime
      }
    }
  }
`;
